module.exports = __webpack_public_path__ + "img/codeImg.72da6e08.jpg";